import React from 'react';

function CheckIcon() {
  return (
    <svg
      width={13}
      height={13}
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth={2.2}
      strokeLinecap='round'
      strokeLinejoin='round'
      aria-hidden='true'
    >
      <path d='M5 12l4.5 4.5L19 7' />
    </svg>
  );
}

// Bravo single-select pill row (handoff: item-level-mass-edit .freq-pills).
// options: [{ value, label }] — same shape as wizard selectvalues. Clicking an
// already-selected pill keeps it selected (no deselect-to-empty).
function PillSelect({ options, value, onChange, label = null }) {
  const pills = options ?? [];

  return (
    <div className='bravo-ds'>
      {label && <div className='us-section-lbl'>{label}</div>}
      <div className='freq-pills'>
        {pills.map((option) => (
          <button
            key={option.value}
            type='button'
            className={option.value === value ? 'freq-pill on' : 'freq-pill'}
            onClick={() => onChange(option.value)}
          >
            {option.value === value && <CheckIcon />} {option.label}
          </button>
        ))}
      </div>
    </div>
  );
}

export default PillSelect;
